export const citGroupTicketConnectionRouter = [
  {
    path: '/service/citGroup/list',
    name: 'CitGroupConnection',
    component: () => import('@/views/service/serviceProvider/citGroup/ProductConnection.vue'),
    meta: {
      title: '中智游门票直连',
      keepAlive: false
    }
  },
  {
    path: '/service/citGroup/orderConnection',
    name: 'CitGroupOrderConnection',
    component: () => import('@/views/service/serviceProvider/citGroup/OrderConnection'),
    meta: {
      title: '中智游订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/citGroup/addAccount',
    name: 'CitGroupAddAccount',
    component: () => import('@/views/service/serviceProvider/citGroup/AddAccount'),
    meta: {
      title: '添加账号',
      keepAlive: false
    }
  }
]